import type { AgenticComponents } from "@p0security/integrations-agentic-shared/components";
import type { FrontendInstaller } from "@p0security/integrations-installer";

import { agenticA2aBridgeInstaller } from "./bridge.ts";
import { agenticGatewayInstaller } from "./gateway.tsx";
import { agenticServerInstaller } from "./mcp.tsx";

export const agenticInstaller: FrontendInstaller<typeof AgenticComponents> = {
  components: {
    "a2a-bridge": agenticA2aBridgeInstaller,
    gateway: agenticGatewayInstaller,
    "log-provider": { items: {} },
    server: agenticServerInstaller,
  },
};
